/** * 系统操作日志 */
<template>
    <div>
        <topTab ref="topTab" :tabData='tabData' @tabChange='changePages'>
            <!-- 搜索筛选 -->
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
                        @change="search">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期：">
                    <el-date-picker v-model="formInline.statisticDate" type="date" value-format="yyyy-MM-dd"
                        format="yyyy年MM月dd日" placeholder="请选择日期" size="small" @change="search">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="btnList">
                    <el-button size="small" v-if="this.$checkBtnPermission('/storeDayReport/index', 'viewPage')"
                        type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
                </el-form-item>
            </el-form>
            <!-- 标题 -->
            <div class="title">
                {{ title }}
            </div>
            <div class="reportContent">
                <div v-if="Object.keys(dayReportInfo).length > 0">
                    <!-- 进店类型信息、顾客数据和新进店顾客信息 -->
                    <el-row :gutter="20" style="display: flex; margin-bottom: 20px;">
                        <!-- 左侧：新进店顾客信息 -->
                        <el-col :span="10" style="display: flex;">
                            <!-- 新进店顾客信息 -->
                            <el-card class="report-card"
                                style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
                                <div slot="header" class="card-header">
                                    <h3><i class="el-icon-user"></i> 新进店顾客信息</h3>
                                </div>
                                <el-table :data="dayReportInfo.reportCustomers || []" border size="small" stripe
                                    max-height="600" style="width: 100%; flex: 1; ">
                                    <el-table-column type="index" label="序号" width="80" align="center" />
                                    <el-table-column prop="receiptionUserName" label="接待人" min-width="100"
                                        align="center" />
                                    <el-table-column prop="inStoreCustomerCount" label="进店顾客数量" width="120"
                                        align="center" />
                                    <el-table-column prop="inStoreOrderCustomerCount" label="进店成交数量" width="150"
                                        align="center" />
                                    <el-table-column label="成交率" width="120" align="center">
                                        <template slot-scope="scope">
                                            {{ ((scope.row.inStoreOrderCustomerCount || 0) /
                                                (scope.row.inStoreCustomerCount ||
                                                    1) * 100).toFixed(2) }}%
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-card>
                        </el-col>
                        <!-- 右侧：今日进店类型、本月进店类型、顾客数据 -->
                        <el-col :span="14" style="display: flex; flex-direction: column; gap: 20px;">
                            <!-- 今日进店类型 -->
                            <el-card class="report-card">
                                <div slot="header" class="card-header" style="">
                                    <h3><i class="el-icon-money"></i> 今日进店类型</h3>
                                    <span style="font-size: 14px; font-weight: 500; color: #606266;">小计：{{
                                        todayInStoreTotal }} 人</span>
                                </div>
                                <el-row :gutter="10" justify="space-around">
                                    <el-col v-for="(item, index) in dayReportInfo.inStoreTypes || []" :key="index"
                                        :span="8">
                                        <div class="stat-item">
                                            <div class="stat-label">{{ item.typeName }}</div>
                                            <div class="stat-value">{{ item.count || 0 }} 人</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="24" v-if="(dayReportInfo.inStoreTypes || []).length === 0">
                                        <div class="empty-data-small">暂无数据</div>
                                    </el-col>
                                </el-row>
                            </el-card>
                            <!-- 本月进店类型 -->
                            <el-card class="report-card">
                                <div slot="header" class="card-header" >
                                    <h3><i class="el-icon-money"></i> 本月进店类型</h3>
                                    <span style="font-size: 14px; font-weight: 500; color: #606266;">小计：{{
                                        monthInStoreTotal }} 人</span>
                                </div>
                                <el-row :gutter="20">
                                    <el-col v-for="(item, index) in dayReportInfo.monthInStoreTypes || []" :key="index"
                                        :span="8">
                                        <div class="stat-item">
                                            <div class="stat-label">{{ item.typeName }}</div>
                                            <div class="stat-value">{{ item.count || 0 }} 人</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="24" v-if="(dayReportInfo.monthInStoreTypes || []).length === 0">
                                        <div class="empty-data-small">暂无数据</div>
                                    </el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                    </el-row>

                    <!-- 顾客数据 -->
                    <el-card class="report-card" style="margin-bottom: 20px;">
                        <div slot="header" class="card-header">
                            <h3><i class="el-icon-user"></i> 顾客数据</h3>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <div class="stat-item">
                                    <div class="stat-label">今日老顾客进店成交</div>
                                    <div class="stat-value">{{ dayReportInfo.oldCustomerSpendOrderCount || 0 }}
                                        单</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="stat-item">
                                    <div class="stat-label">本月总进店顾客数量</div>
                                    <div class="stat-value">{{ dayReportInfo.totalCustomerInStore || 0 }} 人
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="stat-item">
                                    <div class="stat-label">本月进店老顾客成交量</div>
                                    <div class="stat-value">{{ dayReportInfo.monthOldInStoreSpendOrderCount || 0
                                        }} 单
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="stat-item">
                                    <div class="stat-label">本月进店顾客成交量</div>
                                    <div class="stat-value">{{ dayReportInfo.monthInStoreSpendOrderCount || 0 }}
                                        单</div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                    <!-- 今日和本月销售数据 -->
                    <el-row :gutter="20" style="margin-bottom: 20px;">
                        <el-col :span="14">
                            <!-- 今日销售数据 -->
                            <el-card class="report-card">
                                <div slot="header" class="card-header">
                                    <h3><i class="el-icon-document-copy"></i> 今日销售数据</h3>
                                </div>
                                <el-row :gutter="10">
                                    <el-col :span="8">
                                        <div class="stat-item">
                                            <div class="stat-label">商品销售总额</div>
                                            <div class="stat-value">¥{{ dayReportInfo.productMoney || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item">
                                            <div class="stat-label">销售金额</div>
                                            <div class="stat-value">¥{{ dayReportInfo.salesMoney || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item">
                                            <div class="stat-label">实收金额</div>
                                            <div class="stat-value">¥{{ dayReportInfo.realPayMoney || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item">
                                            <div class="stat-label">今日清欠款</div>
                                            <div class="stat-value">¥{{ dayReportInfo.dayClearPayment || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item">
                                            <div class="stat-label">今日欠款</div>
                                            <div class="stat-value">¥{{ dayReportInfo.dayPayment || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item">
                                            <div class="stat-label">会员卡销付款</div>
                                            <div class="stat-value">¥{{ dayReportInfo.dayVipPayMoney || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                        <el-col :span="10">
                            <!-- 本月销售数据 -->
                            <el-card class="report-card">
                                <div slot="header" class="card-header">
                                    <h3><i class="el-icon-document-checked"></i> 本月销售数据</h3>
                                </div>
                                <el-row :gutter="10">
                                    <el-col :span="12">
                                        <div class="stat-item">
                                            <div class="stat-label">本月商品销售总额</div>
                                            <div class="stat-value">¥{{ dayReportInfo.monthProductMoney || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="stat-item">
                                            <div class="stat-label">本月销售金额</div>
                                            <div class="stat-value">¥{{ dayReportInfo.monthSalesMoney || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="stat-item">
                                            <div class="stat-label">本月实收金额</div>
                                            <div class="stat-value">¥{{ dayReportInfo.monthRealPayMoney || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="stat-item">
                                            <div class="stat-label">本月欠款</div>
                                            <div class="stat-value">¥{{ dayReportInfo.monthPayment || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                    </el-row>
                    <!-- 收款类型信息 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <!-- 今日收款类型 -->
                            <el-card class="report-card">
                                <div slot="header" class="card-header">
                                    <h3><i class="el-icon-money"></i> 今日收款类型</h3>
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="8" v-for="(item, index) in dayReportInfo.payMoneys || []"
                                        :key="index">
                                        <div class="stat-item">
                                            <div class="stat-label">{{ item.payTypeName }}</div>
                                            <div class="stat-value">¥{{ item.payMoney || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="24" v-if="(dayReportInfo.payMoneys || []).length === 0">
                                        <div class="empty-data-small">暂无数据</div>
                                    </el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                        <el-col :span="12">
                            <!-- 本月收款类型 -->
                            <el-card class="report-card">
                                <div slot="header" class="card-header">
                                    <h3><i class="el-icon-money"></i> 本月收款类型</h3>
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="8" v-for="(item, index) in dayReportInfo.monthPayMoneys || []"
                                        :key="index">
                                        <div class="stat-item">
                                            <div class="stat-label">{{ item.payTypeName }}</div>
                                            <div class="stat-value">¥{{ item.payMoney || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="24" v-if="(dayReportInfo.monthPayMoneys || []).length === 0">
                                        <div class="empty-data-small">暂无数据</div>
                                    </el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                    </el-row>

                </div>
                <div v-else class="empty-data">
                    <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </topTab>
    </div>

</template>

<script>
import {
    GetStoreDayReport
} from '@/api/productApi.js';
import {
    GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
export default {
    data() {
        return {
            activeTab: '1',
            tabData: [{
                key: '1',
                value: '门店日报表'
            }],
            loading: false, // 显示加载
            formInline: {
                storeKeyId: "",
                statisticDate: new Date(),
            },
            storeList: [],
            dayReportInfo: {},
            title: '日报表',
        };
    },
    // 注册组件
    components: {

    },
    /**
     * 创建完毕
     */
    created() {
        this.GetOrgInfoListByConfig();
        this.search();
    },
    computed: {
        // 计算今日进店总人数
        todayInStoreTotal() {
            if (!this.dayReportInfo.inStoreTypes || this.dayReportInfo.inStoreTypes.length === 0) {
                return 0;
            }
            return this.dayReportInfo.inStoreTypes.reduce((total, item) => {
                return total + (item.count || 0);
            }, 0);
        },
        // 计算本月进店总人数
        monthInStoreTotal() {
            if (!this.dayReportInfo.monthInStoreTypes || this.dayReportInfo.monthInStoreTypes.length === 0) {
                return 0;
            }
            return this.dayReportInfo.monthInStoreTypes.reduce((total, item) => {
                return total + (item.count || 0);
            }, 0);
        }
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        changePages() { },
        search() {
            this.getListData();
        },
        // 获取列表
        getListData() {
            if (!this.$checkBtnPermission('/storeDayReport/index', 'viewPage')) {
                this.$message.error('您没有权限查看门店日报表！');
                return;
            }
            GetStoreDayReport(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.dayReportInfo = res.data;
                        this.title = this.dayReportInfo.statisticDate + '【' + this.dayReportInfo.storeName + '】日报表';
                    } else {
                        this.$message({
                            type: 'info',
                            message: '暂无数据',
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error('数据加载失败，请稍后再试！');
                });
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        res.data.forEach((item) => {
                            this.storeList.push({
                                keyId: item.keyId,
                                value: item.name + '【' + item.remark2 + '】',
                            });
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
    },
};
</script>

<style scoped>
.title {
    font-size: 32px;
    font-weight: 700;
    display: block;
    text-align: center;
    background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.reportContent {
    padding: 5px;
}

.report-card {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

.card-header {
    font-size: 16px;
    font-weight: 600;
    padding: 12px 20px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-header h3 i {
    margin-right: 8px;
    font-size: 18px;
    background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.card-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.basic-info {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    padding: 10px 0;
}

.info-item {
    display: flex;
    align-items: center;
}

.info-item .label {
    font-weight: 500;
    margin-right: 8px;
    color: #606266;
}

.info-item .value {
    font-size: 15px;
    color: #303133;
}

.stat-item {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 4px;
    text-align: center;
    transition: all 0.3s;
    border: 1px solid #e9ecef;
    margin-bottom: 10px;
}

.stat-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-label {
    font-size: 14px;
    color: #000000;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
}

.two-column {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
}

.empty-data {
    text-align: center;
    padding: 60px 20px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .two-column {
        grid-template-columns: 1fr;
    }

    .stat-item {
        padding: 15px;
    }

    .stat-value {
        font-size: 20px;
    }
}

@media (max-width: 768px) {
    .basic-info {
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;
    }

    .el-row {
        display: flex;
        flex-direction: column;
    }

    .el-col {
        width: 100%;
        margin-bottom: 15px;
    }
}

/* 空数据状态 */
.empty-data-small {
    text-align: center;
    padding: 20px;
    color: #909399;
    font-size: 14px;
}
</style>